module.exports = __webpack_public_path__ + "media/src/images/icons/share-b53de5094b73d8a5bbec244d8d86b631.svg";